
document.addEventListener("DOMContentLoaded", function () {
   window.addEventListener('pageshow', function(event) {
    if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
      // This runs only on browser back/forward
      console.log('Back button or browser navigation detected.');

      // Example: reload images or reinit components  
      document.querySelectorAll("img").forEach(img => {
        if (!img.complete || img.naturalWidth === 0) {
          const src = img.src;
          img.src = "";
          img.src = src; // Force reload
        }
      });
    }
  });
 let ul = document.querySelector(".collection-page ul.grid"); // Select the <ul> element
    let dealSection = document.querySelector("#on-collection .deal-of-the-day"); // Select the section
   console.log("dealSection..");
   console.log(dealSection);

    let liItems = ul?.getElementsByTagName("li"); // Get all <li> elements

    if (liItems && liItems.length >= 6 && dealSection) {
    let div = document.createElement("div");
    div.classList.add("custom-div-deal-add-section");
    div.appendChild(dealSection);
    liItems[5].after(div);
   }

});